import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// The apps own every Note writing session. Unsupported clients never load
// this Bridge controller, so the same link remains an ordinary web fallback
// for the browser and for a build that predates the native composer.
export default class extends BridgeComponent {
  static component = "native-note-editor"
  static values = { context: Object }

  // Returning from the composer is the app's business, not this page's: the
  // native side clears the snapshot cache so the reading screen refetches.
  // A reply callback could not do it — dismissing the composer restores the
  // page, which disconnects this controller and drops the pending callback.
  open(event) {
    event.preventDefault()

    this.send("open", this.contextValue)
  }
}
